import React, { useEffect, useState } from 'react';
import { Button, Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { obterDetalhesPrestadorPj } from '~/Services/Service';
import TabHistoricoVH from './components/TabHistoricoVH';
import TabSocios from './components/TabSocios';
import { formatarCnpj } from './utils/formatters';

const data = valor => (valor ? new Date(valor).toLocaleDateString('pt-BR') : '-');

const InfoBox = ({ label, value }) => (
  <div className="hpj-info-box">
    <div className="hpj-info-label">{label}</div>
    <div className="hpj-info-value">{value || '-'}</div>
  </div>
);

const Detalhes = ({ codigo, onVoltar }) => {
  const [detalhe, setDetalhe] = useState(null);

  useEffect(() => {
    if (!codigo) return;
    obterDetalhesPrestadorPj(codigo)
      .then(setDetalhe)
      .catch(err => toast.error(err.message || 'Erro ao carregar detalhes.'));
  }, [codigo]);

  if (!codigo) return null;

  return (
    <div className="hpj-shell hpj-shell--detail">
      <div className="hpj-panel">
        <div className="hpj-detail-head">
          <div>
            <div className="hpj-eyebrow">Prestador PJ</div>
            <h1 className="hpj-detail-title">{detalhe ? detalhe.razao_social : 'Prestador PJ'}</h1>
            {detalhe && (
              <div className="hpj-detail-meta">
                <span className={`hpj-badge ${detalhe.rescindido ? 'hpj-badge--slate' : 'hpj-badge--green'}`}>
                  {detalhe.rescindido ? 'Rescindido' : 'Ativo'}
                </span>
                <span>{formatarCnpj(detalhe.cnpj)}</span> |
                <span>Usuário {detalhe.codigo_usuario}</span>
              </div>
            )}
          </div>
          <Button className="hpj-detail-back-link" variant="link" size="sm" onClick={onVoltar}>
            Voltar
          </Button>
        </div>

        <div className="hpj-tabs">
          <Tabs defaultActiveKey="dados" id="prestador-pj-tabs">
            <Tab eventKey="dados" title="Dados Cadastrais">
              {detalhe && (
                <div className="hpj-info-grid">
                  <InfoBox label="Razão Social" value={detalhe.razao_social} />
                  <InfoBox label="Nome Fantasia" value={detalhe.nome_fantasia} />
                  <InfoBox label="CNPJ" value={formatarCnpj(detalhe.cnpj)} />
                  <InfoBox label="Data de Abertura" value={data(detalhe.data_abertura)} />
                  <InfoBox
                    label="Endereço"
                    value={`${detalhe.endereco_logradouro}, ${detalhe.endereco_numero} - ${detalhe.endereco_cidade}/${detalhe.endereco_uf}`}
                  />
                  <InfoBox label="CEP" value={detalhe.endereco_cep} />
                  <InfoBox label="Banco" value={detalhe.banco} />
                  <InfoBox label="Agência" value={detalhe.agencia} />
                  <InfoBox label="Conta" value={detalhe.conta} />
                  <InfoBox label="Status" value={detalhe.rescindido ? 'Rescindido' : 'Ativo'} />
                </div>
              )}
            </Tab>
            <Tab eventKey="socios" title="Sócios">
              <TabSocios codigoPj={codigo} />
            </Tab>
            <Tab eventKey="historico" title="Histórico Valor/hora">
              <TabHistoricoVH codigoPj={codigo} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Detalhes;
